import { Inject, Injectable } from '@angular/core';
import { TCommonEnvironmentVars } from '@monorepo/types';

export const NPS_END_POINTS = {
  GET_NPS_FEEDBACK_FORM: '/ext/v1/nps/getFeedbackForm',
  SUBMIT_NPS_FEEDBACK: '/ext/v1/nps/submit',
};

@Injectable({
  providedIn: 'root',
})
export class NpsEnvService {
  #BASE_URL: string;

  constructor(@Inject('environment') environment: TCommonEnvironmentVars) {
    const fullUrl: string = environment.protocol + environment.service_host + environment.data_gateway;
    this.#BASE_URL = fullUrl.endsWith('/ext') ? fullUrl.slice(0, -4) : fullUrl;
  }
  public getUrlFromEnv(arg: keyof typeof NPS_END_POINTS): string {
    return this.#BASE_URL + NPS_END_POINTS[arg];
  }
}
